import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment/moment';

import { User } from '../classes/user';
import { AuthenticationService } from './authentication.service';
 
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class UsersService {

  private baseUrl = environment.apiUrl + '/users';

  constructor(private http: HttpClient, private router: Router, private authenticationService: AuthenticationService, private cookieService: CookieService) {

  }

  registerUser (user) {
    var expireDate = moment.utc().add(2, 'hours').toDate();
    return this.http.post(this.baseUrl, user).map(
      (data: any) => {
        this.cookieService.set('perchedToken', data.token, expireDate);
        this.cookieService.set('perchedUser', JSON.stringify(data), expireDate);
      },
      error => {
        return error;
      });
  }

  getUserProfile (userId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/' + userId,  httpOptions);
  }

  updateUserProfile (userId, user) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.patch(this.baseUrl + '/' + userId, user,  httpOptions).map(
      (data: any) => {},
      error => {
        return error;
      });
  }

  updateUserProfileImage (userId, image) {
    let body = new FormData();
    body.append('image', image);
    let httpOptions = { headers: new HttpHeaders( { 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.post(this.baseUrl + '/' + userId + '/image', body,  httpOptions);
  }

  deleteUser (userId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.delete(this.baseUrl + '/' + userId, httpOptions);
  }

}


// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/services/users.service.ts